var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTmus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-710e734c-f091-42e7-80fb-95a5c747a3b3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-7fc13e56-27b1-464f-86e8-7dca031e3346{fill:#e20074;}.uuid-abb4ea70-ef5c-4c9a-a209-757a11c16328{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-0923d2ba-8053-43a8-b91c-69a20da1d181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-733f4c57-d8f5-49c2-9c53-cbfb0b8cfbbd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-e09042cc-452f-4384-8bcc-d1d9806b1da4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-58322443-5b4f-4840-b9c1-db70646faa27",
    className: "uuid-7fc13e56-27b1-464f-86e8-7dca031e3346",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-9a912fa4-bc61-4f10-bde5-6cea66788828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-bb8ae2c1-d1e0-4931-89f7-5ddd795b9884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-e6b727d7-355b-431c-89df-ef60407e948b",
    className: "uuid-abb4ea70-ef5c-4c9a-a209-757a11c16328",
    d: "m125.84,307.64v-64.01h64.01v64.01h-64.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-d899c0f6-920e-4c26-9954-5e9f0b987c39",
    className: "uuid-abb4ea70-ef5c-4c9a-a209-757a11c16328",
    d: "m321.29,307.64v-64.01h64.01v64.01h-64.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-138e60b2-2338-4e8e-9e2b-8d1461f33d55",
    className: "uuid-abb4ea70-ef5c-4c9a-a209-757a11c16328",
    d: "m381.89,98.53h-252.63l-3.41,111.81,17.07,2.56c3.41-33.29,11.95-57.18,25.61-73.4,14.51-16.22,34.99-25.61,61.45-26.46v233c0,20.49-2.56,33.29-8.53,39.26-5.12,5.12-13.66,8.53-25.61,9.39-3.41,0-9.39.85-17.92.85v17.92h156.19v-17.92c-8.53,0-14.51,0-17.92-.85-11.95-.86-20.48-4.27-25.61-9.39-5.97-5.98-8.54-19.63-8.54-39.26V113.89c26.46.85,46.94,9.39,61.45,26.46,14.51,16.22,23.04,40.11,25.6,73.4l17.07-2.56-4.27-112.66Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTmus);
export default __webpack_public_path__ + "static/media/icon_tmus.6140b719b9249729f9d7ed5e282e3dea.svg";
export { ForwardRef as ReactComponent };